import { AccountLOB, AccountStatus, AccountType, CarGaragedState, ProductSubType, } from "../types";
export const DDA = {
    id: "ZUZoalduMVRNZFNTUjhTZwKfo6q-epAJ4kXly7nNwGWXPqQlfbXKrsm1U7fB_Pjqw-GzY_UQ9q8WF0_PiZCDLQ",
    name: "Interest Checking",
    nickName: "My Checking",
    institution: "Ally",
    openDate: "2018-07-15T01:00:00-04:00",
    status: AccountStatus.ACTIVE,
    lob: AccountLOB.DEPOSIT,
    accountNumber: "1061791172",
    ownershipType: "AT",
    type: AccountType.DDA,
    productId: "4004",
    balance: {
        available: 3.75,
        current: 3.75,
    },
    interest: {
        apy: 0.1,
        ytd: 0.01,
    },
    indicator: {
        external: false,
        retirement: false,
        rdc: true,
        transferFrom: true,
        transferTo: true,
    },
    meta: {
        depositTransferQualifyingSpeed: "",
    },
};
export const CMG = {
    id: "ZUZoalduMVRNZFNTUjhTZ55ypc83TVQSanRUN8D7U7t3o9D7wlIOhRQ25fwye6jreiWS8UqACr6dQxpwNLrBUQ",
    name: "NOW Account - CMG",
    nickName: "CMG Account",
    institution: "Ally",
    openDate: "2012-07-26T01:00:00-04:00",
    status: AccountStatus.ACTIVE,
    lob: AccountLOB.DEPOSIT,
    accountNumber: "2127975791",
    ownershipType: "B",
    type: AccountType.CMG,
    productId: "4800",
    balance: {
        available: 14353.19,
        current: 14353.19,
        heloc: 0,
    },
    interest: {
        apy: 2.25,
        ytd: 24.76,
    },
    indicator: {
        external: false,
        retirement: false,
        rdc: true,
        transferFrom: true,
        transferTo: true,
    },
    meta: {
        depositTransferQualifyingSpeed: "",
    },
};
export const SDA = {
    id: "ZUZoalduMVRNZFNTUjhTZ3A4NhADg44TiJ5cYD7Kmbw-KCm3e6_SGZO8QvE30jO7jsGYh3gmoW1WbiCaepAdKw",
    name: "Online Savings Account",
    nickName: "My Savings",
    institution: "Ally",
    openDate: "2018-07-15T01:00:00-04:00",
    status: AccountStatus.ACTIVE,
    lob: AccountLOB.DEPOSIT,
    accountNumber: "2161790130",
    ownershipType: "A",
    type: AccountType.SDA,
    productId: "4107",
    balance: {
        available: 691.91,
        current: 691.91,
    },
    interest: {
        apy: 1.5,
        ytd: 1.24,
    },
    indicator: {
        external: false,
        retirement: false,
        rdc: true,
        transferFrom: true,
        transferTo: true,
    },
    meta: {
        depositTransferQualifyingSpeed: "",
    },
};
export const MMA = {
    id: "ZUZoalduMVRNZFNTUjhTZ9jjwAghpQh03kgx4Ydt1ELkyI0lNFLVRv2WgBe3qXBhgQJQCm4S9JH5pqcOT32tDA",
    name: "Money Market Savings Account",
    nickName: "Money Market",
    institution: "Ally",
    openDate: "2018-07-15T01:00:00-04:00",
    status: AccountStatus.ACTIVE,
    lob: AccountLOB.DEPOSIT,
    accountNumber: "2161791195",
    ownershipType: "A",
    type: AccountType.MMA,
    productId: "4102",
    balance: {
        available: 486.99,
        current: 486.99,
    },
    interest: {
        apy: 2.2,
        ytd: 0.71,
    },
    indicator: {
        external: false,
        retirement: false,
        rdc: true,
        transferFrom: true,
        transferTo: true,
    },
    meta: {
        depositTransferQualifyingSpeed: "",
    },
};
export const CDA = {
    id: "ZUZoalduMVRNZFNTUjhTZwmEbdcyMUrLhjTFYTG5rOLCuPBn3U009LULaKMYLwTIRqETU2OlOFRGDsbCghiLOP",
    name: "High Yield CD - 60 Month",
    nickName: "High Yield CD 5-Year",
    institution: "Ally",
    openDate: "2018-07-15T01:00:00-04:00",
    status: AccountStatus.ACTIVE,
    lob: AccountLOB.DEPOSIT,
    accountNumber: "3061790147",
    ownershipType: "AT",
    type: AccountType.CDA,
    productId: "3509",
    balance: {
        available: 1.03,
        current: 1.03,
    },
    interest: {
        apy: 2.35,
        totalAccrued: 0.00196,
        ytd: 0,
    },
    indicator: {
        cdInGracePeriod: true,
        cdManageBlocked: false,
        cdRenewSpecialRequest: false,
        external: false,
        retirement: false,
        rdc: false,
        transferFrom: false,
        transferTo: false,
    },
    meta: {
        cdMaturityDate: "2023-08-11T02:00:00-04:00",
        cdTerm: "5-Year",
        depositTransferQualifyingSpeed: "",
    },
};
export const CDA2 = {
    id: "ZUZoalduMVRNZFNTUjhTZwmEbdcyMUrLhjTFYTG5rOLCuPBn3U009LULaKMYLwTIRqETU2OlOFRGDsbCghiLOQ",
    name: "High Yield CD - 60 Month",
    nickName: "High Yield CD 5-Year",
    institution: "Ally",
    openDate: "2018-07-15T01:00:00-04:00",
    status: AccountStatus.ACTIVE,
    lob: AccountLOB.DEPOSIT,
    accountNumber: "3061790147",
    ownershipType: "AT",
    type: AccountType.CDA,
    productId: "3509",
    balance: {
        available: 1.03,
        current: 1.03,
    },
    interest: {
        apy: 2.35,
        totalAccrued: 0.00196,
        ytd: 0,
    },
    indicator: {
        cdInGracePeriod: false,
        cdManageBlocked: false,
        cdRenewSpecialRequest: false,
        external: false,
        retirement: false,
        rdc: false,
        transferFrom: false,
        transferTo: false,
    },
    meta: {
        cdMaturityDate: "2020-02-28T02:00:00-04:00",
        cdTerm: "5-Year",
        depositTransferQualifyingSpeed: "",
    },
};
export const IRA = {
    id: "ZUZoalduMVRNZFNTUjhTZwmEbdcyMUrLhjTFYTG5rOLCuPBn3U009LULaKMYLwTIRqETU2OlOFRGDsbCghiLOP",
    name: "High Yield CD - 60 Month",
    nickName: "High Yield CD 5-Year",
    institution: "Ally",
    openDate: "2018-07-15T01:00:00-04:00",
    status: AccountStatus.ACTIVE,
    lob: AccountLOB.DEPOSIT,
    accountNumber: "3061790147",
    ownershipType: "AT",
    type: AccountType.CDA,
    productId: "3509",
    balance: {
        available: 1.03,
        current: 1.03,
    },
    interest: {
        apy: 2.35,
        totalAccrued: 0.00196,
        ytd: 0,
    },
    indicator: {
        cdInGracePeriod: true,
        cdManageBlocked: false,
        cdRenewSpecialRequest: false,
        external: false,
        retirement: true,
        rdc: true,
        transferFrom: true,
        transferTo: true,
    },
    meta: {
        cdMaturityDate: "2023-08-11T02:00:00-04:00",
        cdTerm: "5-Year",
        depositTransferQualifyingSpeed: "",
        retirementPlanNumber: "",
        retirementPlanType: "Roth",
    },
};
export const CLOSED = {
    id: "ZUZoalduMVRNZFNTUjhTZxTOvblsevGA_iO1iBqZyF0ojXgSDLlEcR-GmYmtk539mun1WfgBFggUpSZJPwqiDg",
    name: "Money Market Savings Account",
    nickName: "Money Market Savings",
    institution: "Ally",
    openDate: "2019-11-24T01:00:00-05:00",
    closeDate: "2019-12-24T01:00:00-05:00",
    status: AccountStatus.CLOSED,
    lob: AccountLOB.DEPOSIT,
    accountNumber: "2175324918",
    ownershipType: "B",
    type: AccountType.MMA,
    productId: "4102",
    balance: {
        available: 0,
        current: 0,
    },
    interest: {
        apy: 2.2,
        ytd: 0,
    },
    indicator: {
        external: false,
        retirement: false,
        rdc: false,
        transferFrom: false,
        transferTo: false,
    },
    meta: {
        depositTransferQualifyingSpeed: "",
    },
};
export const INVS = {
    id: "1844620cd0b614f2d9c98a5bda0187f55e0a48887fa2a9b1b2372b752353f968",
    name: "Individual",
    nickName: "Individual",
    institution: "ALLY",
    status: AccountStatus.OPEN,
    lob: AccountLOB.INVEST,
    accountNumber: "60955975",
    type: AccountType.INVS,
    value: {
        cash: 1000,
        market: 0,
        total: 1000,
    },
};
export const INVA = {
    id: "a63ef61e21bb3b0e8e156129ae92860ad1a8a2405def860c6b095ef39bd60278",
    name: "Traditional IRA MP",
    nickName: "Traditional IRA MP",
    institution: "ALLY",
    status: AccountStatus.OPEN,
    lob: AccountLOB.INVEST,
    accountNumber: "90607823",
    type: AccountType.INVA,
    value: {
        cash: 670.6008800000001,
        market: 670.6008800000001,
        total: 671.66088,
    },
};
export const INVW = {
    id: "ac7d6a609bf509b690a7abdb0002632e9fe370f71e1ba11b4a2cc4c651265652",
    name: "Prospect",
    nickName: "Prospect",
    institution: "ALLY",
    status: AccountStatus.OPEN,
    lob: AccountLOB.WEALTH,
    accountNumber: "2FG05031",
    type: AccountType.INVW,
    value: {
        market: 0,
        cash: 100,
        total: 100,
        netReturnPercent: 0,
        yieldPercent: 0,
    },
};
export const MORTGAGE = {
    id: "1",
    name: "Mortgage Account 1",
    institution: "ally",
    lob: AccountLOB.MORTGAGE,
    nickName: "30-Years Fixed Rate Mortgage",
    accountNumber: "90602757",
    type: AccountType.MORTGAGE,
    balance: {
        current: 30000.508,
    },
    meta: {
        amountDue: 15315.620207,
        amountDueDate: "Nov 1,2021",
    },
    status: AccountStatus.ACTIVE,
};
export const HELOC = {
    id: "49873984795",
    name: "Home Equity Line of Credit Account 1",
    institution: "ally",
    lob: AccountLOB.MORTGAGE,
    nickName: "HELOC 1",
    accountNumber: "90602757",
    type: AccountType.HOME_EQUITY,
    balance: {
        current: 3444321.508,
    },
    meta: {
        amountDue: 15315.620207,
        amountDueDate: "Nov 1,2021",
    },
    status: AccountStatus.ACTIVE,
};
export const Auto = {
    id: "101",
    name: "Nissan Altima",
    nickName: "Nissan Altima",
    institution: "ALLY",
    lob: AccountLOB.AUTO,
    status: AccountStatus.ACTIVE,
    accountNumber: "123456789",
    type: AccountType.FINANCE_LEASE,
    balance: {
        total: 54321.09,
    },
    meta: {
        totalAmountDue: 12345.5,
        contractDate: "2022-06-23T17:32:28Z",
        productSubtype: ProductSubType.ABAFFP,
        paidInFullDate: "2022-06-23T17:32:28Z",
        autoPayEnrolled: false,
        directPayEnrolled: false,
        // ex: exclusions: [Exclusions.Loss]
        exclusions: [],
        // ex: bankruptcyCodes: [BankruptcyCodes.BK13]
        bankruptcyCodes: [],
        accountBankrupted: false,
        cycleDate: "2017-07-21T17:32:28Z",
        accountPastDue: false,
        autoPayEditable: false,
        nextPayment: {
            totalAmountDue: 1500.5,
            currentAmountDue: 1500.5,
            dueDate: "2022-05-08T17:32:28Z",
        },
        pastDuePayment: {
            totalAmountDue: 1500.5,
            dueDate: "2022-05-08T17:32:28Z",
            daysPastDue: 5,
        },
        vehicle: {
            make: "Toyota",
            model: "Highlander",
            year: "2021",
            vin: "5A1C4B3",
        },
        catchUpPlanEligibility: {
            maxPeriodAllowed: 8,
            openPromiseToPayFlag: "N",
        },
        alertList: [
            {
                type: "ARN",
                typeDesc: "Account Reservation",
                effectiveDate: "2022-06-23T17:32:28Z",
                expiryDate: "2022-06-23T17:32:28Z",
            },
        ],
        cureNotice: {
            noticeSent: 8,
            expirationDate: "2022-06-23",
        },
        carGaragedState: CarGaragedState.NC,
        // ex: LiveChatAlertCodes: [LiveChatAlertCodes.BK13]
        liveChatAlertCodes: [],
    },
};
export const PLATINUM = {
    id: "123456",
    name: "Credit Card PLATINUM",
    institution: "ally",
    lob: AccountLOB.CC,
    accountNumber: "123456789",
    type: AccountType.PLATINUM,
    status: AccountStatus.NORMAL_STATUS,
    balance: {
        current: 600,
        statement: 300,
        rewards: 10,
    },
    indicator: {
        isActivated: true,
    },
    meta: {
        availableCredit: 5000,
        creditLimit: 5600,
        paymentDue: 25,
        paymentDueDate: "2023-02-15",
        lastStatementDate: "2023-01-15",
        currencyCode: "USD",
    },
};
export const EVERYDAY = {
    id: "123456",
    name: "Credit Card EVERYDAY",
    institution: "ally",
    lob: AccountLOB.CC,
    accountNumber: "123456789",
    type: AccountType.EVERYDAY,
    status: AccountStatus.NORMAL_STATUS,
    balance: {
        current: 1500,
        statement: 700,
        rewards: 10,
    },
    indicator: {
        isActivated: true,
    },
    meta: {
        availableCredit: 500,
        creditLimit: 2000,
        paymentDue: 25,
        paymentDueDate: "2023-02-24",
        lastStatementDate: "2023-01-24",
        currencyCode: "USD",
    },
};
export const UNLIMITED = {
    id: "123456",
    name: "Credit Card UNLIMITED",
    institution: "ally",
    lob: AccountLOB.CC,
    accountNumber: "123456789",
    type: AccountType.UNLIMITED,
    status: AccountStatus.NORMAL_STATUS,
    balance: {
        current: 4000,
        statement: 300,
        rewards: 10,
    },
    indicator: {
        isActivated: true,
    },
    meta: {
        availableCredit: 5000,
        creditLimit: 9000,
        paymentDue: 25,
        paymentDueDate: "2023-05-22",
        lastStatementDate: "2023-04-22",
        currencyCode: "USD",
    },
};
export const accounts = {
    data: [
        DDA,
        MMA,
        SDA,
        CMG,
        CDA,
        CDA2,
        IRA,
        CLOSED,
        INVS,
        INVA,
        INVW,
        MORTGAGE,
        HELOC,
        Auto,
        PLATINUM,
        EVERYDAY,
        UNLIMITED,
    ],
};
//# sourceMappingURL=index.js.map